document.addEventListener("DOMContentLoaded", () => {
    waitForElement();
});
function waitForElement() {
    var id = ".mm-splide-related-product";
    var splideElem = document.querySelector(id);

    if (splideElem != null && splideElem.querySelectorAll(".splide__slide") != null) {
        mmSplideInit(splideElem);
    } else {
        setTimeout(waitForElement, 2000);
    }
}
function mmSplideInit(splideElem) {
    new Splide(splideElem, {
        type: "slide",
        arrows: true,
        pagination: true,
        gap: 24,
        perPage: 1,
        mediaQuery: "min",
        padding: {
            right: 50,
        },
        breakpoints: {
            450: {
                perPage: 2,
            },
            768: {
                perPage: 3,
            },
            990: {
                destroy: true,
            },
        },
    }).mount();
}
